import { IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { computed } from 'mobx';

export class InvoiceEntryListDataService extends DataService<typeof Model.Accounting.Logic.ViewModels.InvoiceEntrySummary, Model.Accounting.Logic.ViewModels.InvoiceEntrySummary, InvoiceEntrySummary> {
	protected map(entity: Model.Accounting.Logic.ViewModels.InvoiceEntrySummary): InvoiceEntrySummary {
		return new InvoiceEntrySummaryModel(entity);
	}

	static make(context?: ContextService): InvoiceEntryListDataService {
		return new InvoiceEntryListDataService(context, ctx => ctx.InvoiceEntrySummaries);
	}
}

export class InvoiceEntrySummaryModel extends EntityModel<Model.Accounting.Logic.ViewModels.InvoiceEntrySummary, InvoiceEntrySummary> implements InvoiceEntrySummary {
	@property<InvoiceEntrySummaryModel>(o => o.entity.id, (e, value) => e.entity.id = value)
	public id: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.dateFrom, (e, value) => e.entity.dateFrom = value)
	public dateFrom: Date;

	@property<InvoiceEntrySummaryModel>(o => o.entity.dateTo, (e, value) => e.entity.dateTo = value)
	public dateTo: Date;

	@property<InvoiceEntrySummaryModel>(o => o.entity.comments, (e, value) => e.entity.comments = value)
	public comments: string;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.price), (e, value) => e.entity.price = value)
	public price: number;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.percent), (e, value) => e.entity.percent = value)
	public percent: number;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.totalNet), (e, value) => e.entity.totalNet = value)
	public totalNet: number;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.totalGross), (e, value) => e.entity.totalGross = value)
	public totalGross: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.invoiceId, (e, value) => e.entity.invoiceId = value)
	public invoiceId: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.taxId, (e, value) => e.entity.taxId = value)
	public taxId: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.quoteEntryId, (e, value) => e.entity.quoteEntryId = value)
	public quoteEntryId: string;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.entryCostPrice), (e, value) => e.entity.entryCostPrice = value)
	public entryCostPrice: number;

	@property<InvoiceEntrySummaryModel>(o => parseFloat(o.entity.entrySellPrice), (e, value) => e.entity.entrySellPrice = value)
	public entrySellPrice: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.entryCostCurrencyCode, (e, value) => e.entity.entryCostCurrencyCode = value)
	public entryCostCurrencyCode: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.entrySellCurrencyCode, (e, value) => e.entity.entrySellCurrencyCode = value)
	public entrySellCurrencyCode: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.quoteId, (e, value) => e.entity.quoteId = value)
	public quoteId: number;

	@property<InvoiceEntrySummaryModel>(o => o.entity.bookingStatus, (e, value) => e.entity.bookingStatus = value)
	public bookingStatus: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.bookingReference, (e, value) => e.entity.bookingReference = value)
	public bookingReference: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.confirmationReference, (e, value) => e.entity.confirmationReference = value)
	public confirmationReference: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.clientsDisplayNames, (e, value) => e.entity.clientsDisplayNames = value)
	public clientsDisplayNames: string;

	@property<InvoiceEntrySummaryModel>(o => JSON.parse(o.entity.occupancy), (e, value) => e.entity.occupancy = value)
	public occupancy: QuoteEntryOccupancy[];

	@computed
	public get occupancyText(): string {
		let adults = 0;
		let children = 0;
		let infants = 0;
		for (const pax of this.occupancy) {
			switch (pax.type) {
				case 0:
					adults++;
					break;
				case 1:
					children++;
					break;
				case 2:
					infants++;
					break;
			}
		}
		return `${adults > 0 ? adults + "A" : ""}${children > 0 ? children + "C" : ""}${infants > 0 ? infants + "I" : ""}`;
	}

	@property<InvoiceEntrySummaryModel>(o => o.entity.productDisplayName, (e, value) => e.entity.productDisplayName = value)
	public productDisplayName: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.reservationDate, (e, value) => e.entity.reservationDate = value)
	public reservationDate: Date;

	@property<InvoiceEntrySummaryModel>(o => o.entity.supplierTitle, (e, value) => e.entity.supplierTitle = value)
	public supplierTitle: string;

	@property<InvoiceEntrySummaryModel>(o => o.entity.invoice, (e, value) => e.entity.invoice = value)
	public invoice: InvoiceSummary;
}



// WEBPACK FOOTER //
// ./src/app/accounting/shared/invoices/list/parts/invoice-entry-list.data.ts